module.exports = __webpack_public_path__ + "d792684e09fdea1a633be46f26c6ab5d.svg";